/**
 * Single source of truth for landing-page URLs.
 *
 * BACKEND_URL is HARDCODED on purpose. The Xandi backend lives at a permanent
 * .emergent.host URL and a marketing page shouldn't depend on build-time env
 * vars (CRA bakes them at build time — if the deploy env var isn't set,
 * process.env.REACT_APP_BACKEND_URL becomes "" and every /api/* call falls
 * back to same-origin, which is the production landing host, not the API).
 */
export const BACKEND_URL = "https://xandi-launch.emergent.host";

/**
 * Public marketing/share host. NOT an API base — this is used to construct
 * the user-facing referral link (e.g. "https://xandibwh.com/?ref=XXXX") that
 * gets displayed in the referral panel and copied to clipboards.
 */
export const PUBLIC_SITE = "https://xandibwh.com";
